import React from "react";
import {TreeSelect} from "antd";

import "antd/dist/reset.css";
import {TreeNode} from "../types/types";
import "./componentsCSS/Sidebar.css";
import {SIDE_BAR_TREE_PLACEHOLDER, VALUES_FOR_SEARCH} from "../consts/consts";

interface SidebarProps {
    selectedNode: TreeNode | null;
    data: any[];
    handleSelect: (newValue: string) => void;
}


const Sidebar: React.FC<SidebarProps> = ({selectedNode, data, handleSelect}) => {
    return (
        <aside className="sidebar">
            <div className="sidebar-content">
                <h3>📂 Select a Category</h3>
                <p>Choose <strong>only one</strong> option from the tree below to see relevant insights.</p>
                <TreeSelect
                    treeData={data}
                    value={selectedNode ? selectedNode.value : undefined}
                    onChange={handleSelect}
                    placeholder={SIDE_BAR_TREE_PLACEHOLDER}
                    treeDefaultExpandAll
                    style={{width: '100%'}}
                    allowClear
                    multiple={false}
                    showSearch={true}
                    treeNodeFilterProp={VALUES_FOR_SEARCH}
                    autoClearSearchValue={false}
                    treeIcon={true}
                    treeLine={true}
                />
            </div>
        </aside>
    );
};

export default Sidebar;